<div class="finder-container">
  <div class="finder-header text-center mb-4">
    <div class="icon-circle mx-auto mb-3">
      <i class="fa fa-search"></i>
    </div>
    <h2 class="h5 mb-2 font-weight-bold text-dark">Trouver la facture pour le Retour</h2>
    <p class="text-muted small mb-0">Renseignez le N° de Commande ou utilisez la recherche détaillée.</p>
  </div>

  <div class="finder-filters">
    <!-- ORDER ID FILTER (OPTION 1) -->
    <div class="search-primary bg-light p-3 p-sm-4 rounded-3 border mb-3">
      <label class="d-block mb-2 font-weight-medium text-dark">
        <i class="fa fa-hashtag text-primary me-2"></i>Recherche rapide par N° Commande
      </label>
      <div class="input-wrapper">
        <i class="fa fa-hashtag icon"></i>
        <input type="number" 
               class="form-control form-control-lg bg-white" 
               placeholder="Numéro de commande..." 
               [(ngModel)]="searchOrderId" 
               [disabled]="!!selectedClient || selectedProducts.length > 0 || !!searchStartDate || !!searchEndDate">
      </div>
    </div>

    <div class="divider">
      <span class="text-uppercase small font-weight-bold tracking-wide">Ou recherche détaillée</span>
    </div>

    <!-- ADVANCED FILTERS (MANDATORY IF NO ORDER ID) -->
    <div class="search-advanced p-3 p-sm-4 rounded-3 border mt-3" [class.disabled-block]="!!searchOrderId">
      <div class="row gx-sm-4 gy-3">
        <!-- PRODUCT FILTER -->
        <div class="col-md-6 col-12 mb-3 mb-md-0 d-flex flex-column">
          <label class="font-weight-medium text-dark mb-2">Produit(s) Retourné(s) <span class="text-danger">*</span></label>
          
          <div class="input-wrapper mb-2">
            <i class="fa fa-barcode icon"></i>
            <input type="text" 
                   #productSearchInput
                   class="form-control" 
                   placeholder="Scannez ou cherchez..." 
                   [(ngModel)]="searchTerm" 
                   (input)="onProductSearchChange($event)"
                   (focus)="showProductDropdown = true"
                   [disabled]="!!searchOrderId">
            <div class="search-dropdown shadow-lg rounded-3" *ngIf="showProductDropdown && productsToDisplay.length > 0">
              <div class="search-dropdown-item d-flex align-items-center" *ngFor="let p of productsToDisplay" (click)="selectProduct(p)">
                <i class="fa fa-cube text-muted me-2" style="font-size: 14px; opacity: 0.7;"></i>
                <div class="d-flex flex-column">
                  <span class="font-weight-medium text-dark">{{ p.name }}</span>
                  <span class="text-muted small" style="font-size: 11px;">Ref: {{ p.codeBare }}</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Badges below input -->
          <div class="selected-badges-container d-flex flex-wrap mt-2" *ngIf="selectedProducts.length > 0">
            <ng-container *ngFor="let p of selectedProducts | slice:0:2; let i = index">
              <div class="selected-badge">
                <span class="text-truncate" style="max-width: 150px;" title="{{ p.name }}">{{ p.name }}</span>
                <button class="remove-btn" (click)="removeProduct(i)"><i class="fa fa-times"></i></button>
              </div>
            </ng-container>
            
            <!-- +X badge for remaining products -->
            <div class="selected-badge more-badge bg-primary text-white border-primary" *ngIf="selectedProducts.length > 2">
              <span class="font-weight-bold" style="font-size: 12px;">+{{ selectedProducts.length - 2 }} autre(s)</span>
            </div>
          </div>
        </div>

        <!-- CLIENT FILTER -->
        <div class="col-md-6 col-12">
          <label class="font-weight-medium text-dark mb-2">Client <span class="text-danger">*</span></label>
          <div class="input-wrapper" *ngIf="!selectedClient">
            <i class="fa fa-user icon"></i>
            <input type="text" 
                   #clientSearchInput
                   class="form-control" 
                   placeholder="Rechercher un client..." 
                   [(ngModel)]="clientSearchTerm" 
                   (input)="onClientSearchChange($event)"
                   (focus)="showClientDropdown = true"
                   [disabled]="!!searchOrderId">
            <div class="search-dropdown shadow-lg rounded-3" *ngIf="showClientDropdown && filteredClients.length > 0">
              <div class="search-dropdown-item d-flex align-items-center" *ngFor="let c of filteredClients" (click)="selectClient(c)">
                <div class="avatar-circle bg-light text-primary font-weight-bold d-flex align-items-center justify-content-center me-3" style="width: 32px; height: 32px; border-radius: 50%;">
                  {{ c.firstName?.charAt(0) }}{{ c.lastName?.charAt(0) }}
                </div>
                <div class="d-flex flex-column">
                  <span class="font-weight-medium text-dark">{{ c.firstName }} {{ c.lastName }}</span>
                  <span class="text-muted small" style="font-size: 11px;"><i class="fa fa-phone me-1"></i>{{ c.phoneNumber || 'N/A' }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="selected-badge d-flex w-100 justify-content-between align-items-center mb-0" style="padding: 10px 14px;" *ngIf="selectedClient">
            <span class="text-truncate">{{ selectedClient.firstName }} {{ selectedClient.lastName }}</span>
            <button (click)="removeClient()"><i class="fa fa-times"></i></button>
          </div>
        </div>
      </div>

      <!-- DATE RANGE FILTER -->
      <div class="row mt-3">
        <div class="col-12">
          <label class="font-weight-medium text-dark mb-2">Période d'achat (Optionnelle)</label>
          <div class="date-range-container d-flex flex-column flex-sm-row align-items-sm-center justify-content-between" style="gap: 12px;">
            <div class="input-wrapper flex-grow-1 w-100">
              <i class="fa fa-calendar icon"></i>
              <input type="date" 
                     class="form-control" 
                     [(ngModel)]="searchStartDate" 
                     [disabled]="!!searchOrderId"
                     title="Date de début">
            </div>
            <span class="date-separator text-muted text-center font-weight-medium flex-shrink-0">jusqu'au</span>
            <div class="input-wrapper flex-grow-1 w-100">
              <i class="fa fa-calendar icon"></i>
              <input type="date" 
                     class="form-control" 
                     [(ngModel)]="searchEndDate" 
                     [disabled]="!!searchOrderId"
                     title="Date de fin">
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- SEARCH BUTTON -->
    <button class="btn-search mt-4 w-100 d-flex justify-content-center align-items-center" 
            style="gap: 8px;"
            (click)="searchOrders()" 
            [disabled]="(!searchOrderId && (selectedProducts.length === 0 || !selectedClient)) || isSearchingOrders">
      <i class="fa fa-search" *ngIf="!isSearchingOrders"></i>
      <i class="fa fa-spinner fa-spin" *ngIf="isSearchingOrders"></i>
      <span>{{ isSearchingOrders ? 'Recherche en cours...' : 'Chercher les commandes' }}</span>
    </button>
  </div>

  <!-- RESULTS SECTION (Keep similar but polished) -->
  <div class="results-section mt-4 pt-4 border-top" *ngIf="hasSearched">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <h3 class="results-title mb-0 font-weight-bold text-dark" style="font-size: 16px;">
        Résultats de la recherche
      </h3>
      <span class="badge bg-primary rounded-pill py-1 px-2">{{ foundOrders.length }} Trouvé(s)</span>
    </div>

    <div class="no-results p-4 text-center bg-light rounded-3 border" *ngIf="foundOrders.length === 0 && !isSearchingOrders">
      <i class="fa fa-folder-open-o text-muted mb-3 d-block mx-auto" style="font-size: 32px;"></i>
      <p class="text-muted mb-0 font-weight-medium">Aucune commande trouvée selon ces critères.</p>
    </div>

    <div class="orders-list" *ngIf="foundOrders.length > 0">
      <div class="order-card p-3 rounded-3 border mb-3 bg-white d-flex flex-column flex-sm-row justify-content-between align-items-sm-center" *ngFor="let order of foundOrders">
        <div class="order-info mb-3 mb-sm-0 w-100 me-3">
          <div class="order-id font-weight-bold text-dark mb-1 d-flex align-items-center">
            <span>Commande #{{ order.id }}</span>
            <span class="badge bg-warning text-dark ms-2 font-weight-normal px-2 py-1" style="font-size: 11px;" *ngIf="order.hasReturns" title="Cette commande a déjà des retours.">
               <i class="fa fa-exclamation-triangle me-1"></i> Avoirs
            </span>
          </div>
          <div class="order-details text-muted small d-flex flex-wrap align-items-center mb-2" style="gap: 8px;">
            <span><i class="fa fa-calendar-o me-1"></i>{{ order.orderDate | date:'dd/MM/yyyy HH:mm' }}</span>
            <span class="d-none d-sm-inline font-weight-medium opacity-50">•</span>
            <span><i class="fa fa-user-o me-1"></i>{{ order.clientDTO?.firstName || 'Client' }} {{ order.clientDTO?.lastName || 'Divers' }}</span>
          </div>
          <div class="order-total font-weight-bold text-primary" style="font-size: 15px;">
            Total: MAD {{ order.total | number:'1.2-2' }}
          </div>
        </div>
        <button class="btn-refund d-flex align-items-center justify-content-center flex-shrink-0" (click)="openReturnDialog(order)">
          <i class="fa fa-reply me-2"></i> Rembourser
        </button>
      </div>
    </div>
  </div>

  <div class="dialog-actions mt-3 pt-3 border-top d-flex justify-content-end">
    <button mat-button class="btn-close-dialog px-4 py-2" (click)="close()">Fermer</button>
  </div>
</div>
